import {
  Navbar,
  Nav,
  NavItem,
  Col,
  Tooltip
} from "reactstrap";
import {
  Link,
  // NavLink as RRNavLink
} from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { SchoolContext } from "../context/SchoolContext";
import { useHistory } from "react-router-dom";
import { utcToZonedTime } from 'date-fns-tz';
import { format } from 'date-fns';
import { Notification } from "./Logo";
// import { NotificationModal } from "./BaseModal";
import { idExists } from "../utils/NumberUtils";
import NotificationBox from "./NotificationBox";

const NavMenu = (props) => {

  const { schoolList, message } = useContext(SchoolContext);
  const history = useHistory();
  const [currentDateTime, setCurrentDateTime] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [userToggle, setUserToggle] = useState(false)
  const pathname = history["location"].pathname
  const school_id = Number(pathname.split('/').pop());

  const [notifNumber, setNotifNumber] = useState(0);

  const toggleModal = () => {
    openModal === true ? setOpenModal(false) : setOpenModal(true);
    setNotifNumber(0);
  };


  const convertToZonedTime = (date) => {
    return utcToZonedTime(date.toISOString(), 'Asia/Tokyo');
  };

  const toggle = () => {
    setUserToggle(!userToggle)
  }

  useEffect(() => {
    const currentDateTimeInterval = setInterval(() => {
      setCurrentDateTime(convertToZonedTime(new Date()));
    }, 1000);

    return () => {
      clearInterval(currentDateTimeInterval)
      // localStorage.removeItem("curr_school");
    };
  }, []);

  useEffect(() => {
    setNotifNumber(message && message.length ? message.length : 0);
  }, [message]);

  useEffect(() => {
    if (pathname === '/home' || pathname === ' /home/setting') {
      setOpenModal(false);
    }
  }, [pathname]);

  return (
    <>
      {/* <NotificationModal
        open={openModal}
        content={
          message && message.length > 0 ? message.map((data) => {
            return (
              <>
                <div className="mt-2 px-2">
                  <span>{data.target_time}</span> <br />
                  <span>{data.title}</span> <br />
                  <span>{data.content}</span>
                </div>
              </>
            )
          }) : "現在通知はありません。"
        }
        handleOpen={closeModal}
        modalStyle="modal-content1"
      /> */}

      <Navbar id="topnav">
        <div className="row">
          <Col md={2} lg={3} xl={2} className="col-6 logoSection">
            <Nav>
              <NavItem>
                <Link to="/home"
                  onClick={() => {
                    // localStorage.removeItem('curr_school');
                    // setTimeout(() => {
                    //   window.location.reload();
                    // })
                  }}
                // className="cursorPoint"
                >
                  <img src="/img/logo.png" alt="logo" id="logo-big" />
                </Link>
              </NavItem>
            </Nav>
          </Col>
          <Col md={9} lg={8} xl={9} className="flex-row justify-content-center navItemsInfo">
            {!Number.isNaN(school_id) && school_id > 0 && schoolList.length > 0 ?
              <Nav className="justify-content-center time px-5 location-nav">

                <NavItem id="username">
                  <svg width="15" height="20" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg__align">
                    <path fillRule="evenodd" clipRule="evenodd" d="M8.46761 6.42997C7.19528 6.42997 6.16385 7.46139 6.16385 8.73372C6.16385 10.006 7.19528 11.0375 8.46761 11.0375C9.73994 11.0375 10.7714 10.006 10.7714 8.73372C10.7714 7.46139 9.73994 6.42997 8.46761 6.42997ZM4.62802 8.73372C4.62802 6.61317 6.34706 4.89413 8.46761 4.89413C10.5882 4.89413 12.3072 6.61317 12.3072 8.73372C12.3072 10.8543 10.5882 12.5733 8.46761 12.5733C6.34706 12.5733 4.62802 10.8543 4.62802 8.73372Z" fill="#233C6B" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M8.46761 1.82246C6.63463 1.82246 4.87672 2.55061 3.58061 3.84672C2.28449 5.14283 1.55634 6.90074 1.55634 8.73372C1.55634 11.9129 3.33165 14.8077 5.20749 16.9649C6.13603 18.0327 7.06654 18.8936 7.76508 19.4874C8.04133 19.7222 8.28042 19.9145 8.46761 20.0605C8.65479 19.9145 8.89388 19.7222 9.17014 19.4874C9.86867 18.8936 10.7992 18.0327 11.7277 16.9649C13.6036 14.8077 15.3789 11.9129 15.3789 8.73372C15.3789 6.90074 14.6507 5.14283 13.3546 3.84672C12.0585 2.55061 10.3006 1.82246 8.46761 1.82246ZM8.46761 21.0204C8.02724 21.6495 8.02702 21.6494 8.02678 21.6492L8.02614 21.6487L8.02434 21.6475L8.01867 21.6435L7.99914 21.6296C7.98255 21.6177 7.95887 21.6007 7.92859 21.5786C7.86804 21.5344 7.78103 21.4699 7.67133 21.3861C7.45201 21.2184 7.14159 20.9731 6.77039 20.6576C6.02908 20.0275 5.0398 19.1126 4.04854 17.9727C2.08479 15.7144 0.0205078 12.4658 0.0205078 8.73372C0.0205078 6.49341 0.910468 4.34486 2.49461 2.76072C4.07874 1.17658 6.2273 0.286621 8.46761 0.286621C10.7079 0.286621 12.8565 1.17658 14.4406 2.76072C16.0247 4.34486 16.9147 6.49341 16.9147 8.73372C16.9147 12.4658 14.8504 15.7144 12.8867 17.9727C11.8954 19.1126 10.9061 20.0275 10.1648 20.6576C9.79363 20.9731 9.4832 21.2184 9.26388 21.3861C9.15419 21.4699 9.06717 21.5344 9.00662 21.5786C8.97634 21.6007 8.95267 21.6177 8.93608 21.6296L8.91655 21.6435L8.91087 21.6475L8.90907 21.6487L8.90844 21.6492C8.9082 21.6494 8.90798 21.6495 8.46761 21.0204ZM8.46761 21.0204L8.90844 21.6492C8.64403 21.8343 8.29119 21.8343 8.02678 21.6492L8.46761 21.0204Z" fill="#233C6B" />
                  </svg>
                  {schoolList.length > 0 ? idExists(schoolList, school_id) ? schoolList[school_id - 1].user_name.length > 7 ? `${schoolList[school_id - 1].user_name.slice(0, 7)}...` : schoolList[school_id - 1].user_name : '' : ''}
                </NavItem>
                <Tooltip target={"username"} placement={'bottom'} isOpen={userToggle} toggle={toggle}>
                  {schoolList.length > 0 ? idExists(schoolList, school_id) ? schoolList[school_id - 1].user_name : '' : ''}
                </Tooltip>

              </Nav>
              : ''}
            <Nav className="justify-content-center time date-time px-5 date-nav">
              <NavItem>
                <svg width="15" height="20" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg__align">
                  <path fillRule="evenodd" clipRule="evenodd" d="M0.412964 3.35829C0.412964 2.51007 1.10058 1.82246 1.9488 1.82246H17.3072C18.1554 1.82246 18.843 2.51007 18.843 3.35829V18.7167C18.843 19.5649 18.1554 20.2525 17.3072 20.2525H1.9488C1.10058 20.2525 0.412964 19.5649 0.412964 18.7167V3.35829ZM17.3072 3.35829H1.9488V18.7167H17.3072V3.35829Z" fill="#233C6B" />
                  <path fillRule="evenodd" clipRule="evenodd" d="M14.2355 0.286621C14.6596 0.286621 15.0034 0.63043 15.0034 1.05454V4.12621C15.0034 4.55032 14.6596 4.89413 14.2355 4.89413C13.8114 4.89413 13.4676 4.55032 13.4676 4.12621V1.05454C13.4676 0.63043 13.8114 0.286621 14.2355 0.286621Z" fill="#233C6B" />
                  <path fillRule="evenodd" clipRule="evenodd" d="M5.02047 0.286621C5.44458 0.286621 5.78839 0.63043 5.78839 1.05454V4.12621C5.78839 4.55032 5.44458 4.89413 5.02047 4.89413C4.59636 4.89413 4.25255 4.55032 4.25255 4.12621V1.05454C4.25255 0.63043 4.59636 0.286621 5.02047 0.286621Z" fill="#233C6B" />
                  <path fillRule="evenodd" clipRule="evenodd" d="M0.412964 7.19788C0.412964 6.77377 0.756772 6.42997 1.18088 6.42997H18.0751C18.4992 6.42997 18.843 6.77377 18.843 7.19788C18.843 7.62199 18.4992 7.9658 18.0751 7.9658H1.18088C0.756772 7.9658 0.412964 7.62199 0.412964 7.19788Z" fill="#233C6B" />
                  <path fillRule="evenodd" clipRule="evenodd" d="M13.6425 10.5109C13.9334 10.8196 13.9189 11.3056 13.6102 11.5964L9.12749 15.8199C8.83099 16.0993 8.36795 16.0985 8.0724 15.8182L5.64385 13.5144C5.33616 13.2225 5.32335 12.7365 5.61523 12.4288C5.90711 12.1211 6.39316 12.1083 6.70085 12.4001L8.60269 14.2043L12.557 10.4786C12.8657 10.1877 13.3517 10.2022 13.6425 10.5109Z" fill="#233C6B" />
                </svg>
                {!!currentDateTime && `${format(currentDateTime, ' yyyy年MM月dd日')}`}
              </NavItem>
            </Nav>
            <Nav className="justify-content-center time date-time px-5 time-nav">
              <NavItem>
                <svg width="15" height="20" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg__align">
                  <path fillRule="evenodd" clipRule="evenodd" d="M10.4846 1.59043C5.81944 1.59043 2.03755 5.37233 2.03755 10.0375C2.03755 14.7027 5.81944 18.4846 10.4846 18.4846C15.1498 18.4846 18.9317 14.7027 18.9317 10.0375C18.9317 5.37233 15.1498 1.59043 10.4846 1.59043ZM0.501709 10.0375C0.501709 4.52411 4.97122 0.0545959 10.4846 0.0545959C15.9981 0.0545959 20.4676 4.52411 20.4676 10.0375C20.4676 15.551 15.9981 20.0205 10.4846 20.0205C4.97122 20.0205 0.501709 15.551 0.501709 10.0375Z" fill="#233C6B" />
                  <path fillRule="evenodd" clipRule="evenodd" d="M10.4846 3.89419C10.9088 3.89419 11.2526 4.23799 11.2526 4.6621V9.26961H15.8601C16.2842 9.26961 16.628 9.61342 16.628 10.0375C16.628 10.4616 16.2842 10.8054 15.8601 10.8054H10.4846C10.0605 10.8054 9.71673 10.4616 9.71673 10.0375V4.6621C9.71673 4.23799 10.0605 3.89419 10.4846 3.89419Z" fill="#233C6B" />
                </svg>
                {!!currentDateTime && `${format(currentDateTime, 'HH')}`}:
                {!!currentDateTime && `${format(currentDateTime, 'mm')}`}:
                {!!currentDateTime && `${format(currentDateTime, 'ss')}`}
              </NavItem>
            </Nav>
          </Col>
          <Col md={1} lg={1} xl={1} className="col-6 notifSection">
            {!Number.isNaN(school_id) && school_id > 0 ?
              <Nav className="justify-content-center navNotif" >
                <NavItem className="test">
                  <Notification setValue={toggleModal} />
                  {/* {message && message.data.length > 0 ? <div className="notification">
                    <span> {message.data.length}</span>
                  </div> : ""} */}
                  <NotificationBox message={message} open={openModal} handleToggle={toggleModal} />

                  <div className={`notification ${notifNumber === 0 ? 'hidden' : ''}`} onClick={() => toggleModal()}>
                    <span> {notifNumber} </span>
                  </div>
                </NavItem>
              </Nav>
              : ""}
          </Col>
        </div>
      </Navbar>

    </>
  );
};

export default NavMenu;
